import RichText from '~/components/ui/RichText.vue';
import { useGetDisplayOptionsClasses } from '~/composables/useGetDisplayOptionsClasses';
import AzImg from '~/components/Atoms/AzImg.vue';
export default defineComponent({
  name: 'BlockImageTextListTipTiles',
  components: {
    RichText: RichText,
    AzImg: AzImg
  },
  props: {
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    title: {
      type: String,
      default: ''
    },
    displayOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup(props) {
    var classes = useGetDisplayOptionsClasses(props.displayOptions);
    var getItemDisplayOptions = function getItemDisplayOptions(item) {
      if (!item.displayOptions) return;
      var itemClasses = useGetDisplayOptionsClasses(item.displayOptions);
      return itemClasses.container;
    };
    var getImageUrl = function getImageUrl(item) {
      var _item$image;
      return (item === null || item === void 0 ? void 0 : (_item$image = item.image) === null || _item$image === void 0 ? void 0 : _item$image.url) || null;
    };
    return {
      getImageUrl: getImageUrl,
      getItemDisplayOptions: getItemDisplayOptions,
      classes: classes
    };
  }
});